import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import commonFr from "@/locales/fr/common.json";
import homeFr from "@/locales/fr/home.json";
import servicesFr from "@/locales/fr/services.json";
import investFr from "@/locales/fr/investissements.json";
import portfolioFr from "@/locales/fr/portfolio.json";
import conformiteFr from "@/locales/fr/conformite.json";
import cabinetFr from "@/locales/fr/cabinet.json";
import equipeFr from "@/locales/fr/equipe.json";
import contactFr from "@/locales/fr/contact.json";
import mentionsFr from "@/locales/fr/mentions.json";

import commonEn from "@/locales/en/common.json";
import homeEn from "@/locales/en/home.json";
import servicesEn from "@/locales/en/services.json";
import investEn from "@/locales/en/investissements.json";
import portfolioEn from "@/locales/en/portfolio.json";
import conformiteEn from "@/locales/en/conformite.json";
import cabinetEn from "@/locales/en/cabinet.json";
import equipeEn from "@/locales/en/equipe.json";
import contactEn from "@/locales/en/contact.json";
import mentionsEn from "@/locales/en/mentions.json";

import commonDe from "@/locales/de/common.json";
import homeDe from "@/locales/de/home.json";
import servicesDe from "@/locales/de/services.json";
import investDe from "@/locales/de/investissements.json";
import portfolioDe from "@/locales/de/portfolio.json";
import conformiteDe from "@/locales/de/conformite.json";
import cabinetDe from "@/locales/de/cabinet.json";
import equipeDe from "@/locales/de/equipe.json";
import contactDe from "@/locales/de/contact.json";
import mentionsDe from "@/locales/de/mentions.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      fr: { common: commonFr, home: homeFr, services: servicesFr, investissements: investFr, portfolio: portfolioFr, conformite: conformiteFr, cabinet: cabinetFr, equipe: equipeFr, contact: contactFr, mentions: mentionsFr },
      en: { common: commonEn, home: homeEn, services: servicesEn, investissements: investEn, portfolio: portfolioEn, conformite: conformiteEn, cabinet: cabinetEn, equipe: equipeEn, contact: contactEn, mentions: mentionsEn },
      de: { common: commonDe, home: homeDe, services: servicesDe, investissements: investDe, portfolio: portfolioDe, conformite: conformiteDe, cabinet: cabinetDe, equipe: equipeDe, contact: contactDe, mentions: mentionsDe },
    },
    fallbackLng: "fr",
    lng: "fr",
    supportedLngs: ["fr", "en", "de"],
    defaultNS: "common",
    interpolation: { escapeValue: false },
    returnObjects: true,
    detection: { order: ["localStorage"], caches: ["localStorage"] },
  });

i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
